import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoaderService } from 'src/app/services/lazy-loader.service';
import * as $ from 'jquery';
import { ReceivableService } from 'src/app/services/receivable.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertComponent } from 'src/app/alert/alert.component';

declare var $: any;

@Component({
  selector: 'app-list-retur',
  templateUrl: './list-retur.component.html',
  styleUrls: ['./list-retur.component.css']
})
export class ListReturComponent implements OnInit {
  @ViewChild('alertComponent') alertComponent: AlertComponent;
  
  start: string = '';
  end: string = '';

  titleContent: string;
  infoContent: any;
  listReturn = [];
  isLoading = false;

  constructor(
    private lazyLoaderService: LazyLoaderService,
    private receivableService: ReceivableService,
    private sanitizer: DomSanitizer,
    private changeDetection: ChangeDetectorRef
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.lazyLoaderService.loadScript(
        'https://cdn.jsdelivr.net/npm/gijgo@1.9.6/js/gijgo.min.js'
      );
      this.datepickerScript();
    });

    this.resetFilter();
    this.getReturnInfo();
  }

  collapseScript(): void {
    $(document).ready(function () {
      $(".collapse.show").each(function(){
        $(this).prev(".card-header").find(".fa").addClass("fa-chevron-up").removeClass("fa-chevron-down");
      });

      $(".collapse").on('show.bs.collapse', function(){
        $(this).prev(".card-header").find(".fa").removeClass("fa-chevron-down").addClass("fa-chevron-up");
      }).on('hide.bs.collapse', function(){
        $(this).prev(".card-header").find(".fa").removeClass("fa-chevron-up").addClass("fa-chevron-down");
      });
      
    });
  }

  datepickerScript(): void {
    const that = this;
    $(document).ready(function () {
      $('.datepicker').remove();

      $('#startDate').datepicker({
        autoclose: true,
        uiLibrary: 'bootstrap4',
        format: 'yyyy-mm-dd',
        change: function (e) {
          that.startDateOnChanged();
        },
      });
      $('#endDate').datepicker({
        autoclose: true,
        uiLibrary: 'bootstrap4',
        format: 'yyyy-mm-dd',
        change: function (e) {
          that.endDateOnChanged();
        },
      });

      $('body').click(function (evt) {
        if ($(evt.target).closest('.input-group-append').length) {
          return;
        }
      });
    });
  }

  startDateOnChanged() {
    if (this.start !== $('#startDate').val()) {
      this.start = $('#startDate').val();
      if (this.end !== '') {
        if (new Date(this.end) < new Date(this.start)) {
          this.alertComponent.show('', 'Tanggal mulai tidak boleh melebihi tanggal berakhir');
          this.end = '';
          $('#endDate').val('');
        }
      }

      this.getReturnList();
    }
  }

  endDateOnChanged() {
    if (this.end !== $('#endDate').val()) {
      this.end = $('#endDate').val();
      if (this.start !== '') {
        if (new Date(this.end) < new Date(this.start)) {
          this.alertComponent.show('', 'Tanggal mulai tidak boleh melebihi tanggal berakhir');
          this.start = '';
          $('#startDate').val('');
        }
      }

      this.getReturnList();
    }
  }

  resetFilter() {
    $('#startDate').val('');
    $('#endDate').val('');

    this.start = '';
    this.end = '';
    this.getReturnList();
  }

  getReturnInfo() {
    this.receivableService.getReturnInfo(
      (response) => {
        this.titleContent = response.data.title;
        this.infoContent = this.sanitizer.bypassSecurityTrustHtml(
          response.data.content
        );
      }, 
      (err) => {
        console.log(err);
      }
    );
  }

  getReturnList() {
    this.isLoading = true;
    this.receivableService.getReturnList(this.start, this.end,
      (response) => {
        this.isLoading = false;
        this.listReturn = response.data;
        this.changeDetection.detectChanges();

        this.collapseScript();
      },
      (err) => {
        this.isLoading = false;
        console.log(err);
      }
    );
  }
}
